export default __webpack_public_path__ + "static/media/nuodb.94cc3b8f.svg";